import { render, staticRenderFns } from "./LoadSetting.vue?vue&type=template&id=70ee2422&scoped=true&"
import script from "./LoadSetting.vue?vue&type=script&lang=js&"
export * from "./LoadSetting.vue?vue&type=script&lang=js&"
import style0 from "./LoadSetting.vue?vue&type=style&index=0&id=70ee2422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee2422",
  null
  
)

export default component.exports